var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuCollapseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H12H21V21H3V3ZM4.5 4.5V19.5H10.5V4.5H4.5ZM12 19.5H19.5V4.5H12V19.5ZM8.13986 9.47021L9.19986 10.5302L7.72986 12.0002L9.19986 13.4702L8.13986 14.5302L5.60986 12.0002L8.13986 9.47021Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuCollapseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Menu_Collapse_Icon.eab51e30d052a066ae7b7db4f3dd8821.svg";